import styled from "@emotion/styled";
import { useGame } from "~/app";
import { AgentIcon, FactionType } from "~/business";
import { XActionSlot, XFactionRamp } from "~/jsx/components/design";
import { useActions } from "~/jsx/hook";
import { Spacing } from "~/jsx/theme";
import { parseEnumOrError } from "~/utils";
import { XActionSlotSection } from "./XActionSlotSection";

const actionSlotMargin = Spacing.actions;
const orderedFactions = [
  FactionType.Emperor,
  FactionType.Guild,
  FactionType.BeneGesserit,
  FactionType.Fremen,
];

const Container = styled.div`
  & > :first-child {
    border-top-left-radius: 6px;
  }
  & > :last-child {
    border-top-right-radius: 6px;
  }
`;

export const XFactionRamps = () => {
  const { game } = useGame();
  const { onActionSlotClickFactory } = useActions();
  const { players, actionSlots } = game;

  return (
    <Container style={{ display: "flex", flexDirection: "row" }}>
      {orderedFactions.map((faction) => {
        const cubeLevels = players.map((player) => ({
          level: player.getFactionAffinity(faction).level,
          playerId: player.id,
        }));
        const agentIcon = parseEnumOrError(AgentIcon, faction);
        const associatedActions = actionSlots.filter(
          (_) => _.agentIcon === agentIcon
        );
        const isPointTaken = players.some(
          (player) => player.getFactionAffinity(faction).hasPoint
        );
        return (
          <XActionSlotSection key={faction} agentIcon={agentIcon}>
            <div
              style={{
                display: "flex",
                gap: actionSlotMargin,
                width: "fit-content",
                alignItems: "center",
              }}
            >
              <div>
                <XFactionRamp
                  faction={faction}
                  cubeLevels={cubeLevels}
                  hasPoint={!isPointTaken}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: actionSlotMargin,
                }}
              >
                {associatedActions.map((actionSlot, index) => (
                  <XActionSlot
                    actionSlot={actionSlot}
                    key={index}
                    onClick={onActionSlotClickFactory(actionSlot)}
                    allowOverlay={true}
                    noShadow={true}
                  />
                ))}
              </div>
            </div>
          </XActionSlotSection>
        );
      })}
    </Container>
  );
};
